import dataBoard from "./modules/dataBoard";

export default {
  dataBoard,
}



// WEBPACK FOOTER //
// ./src/store/dataBoard/index.js